import type { PaymentFeesTranslations } from "../interfaces/paymentFees";

export const paymentFeesTranslations: PaymentFeesTranslations = {
  // Página
  page_title: "Tarifas e comissões",
  page_subtitle:
    "Quanto cobramos de cada organização para movimentar dinheiro e quanto o provedor nos cobra, corredor por corredor.",
  refresh_button: "Atualizar",
  refresh_aria: "Recarregar tarifas e comissões",
  button_new_fee: "Regra avançada",

  // Guia
  guide_title: "Como funcionam os preços?",
  guide_commission_title: "Comissão Coloca e custo do provedor",
  guide_commission_body:
    "A comissão é o que cobramos da organização em cada operação: é nossa receita. O custo do provedor é o que o provedor de pagamentos cobra da Coloca. Um corredor precisa dos dois para funcionar.",
  guide_scope_title: "Preço geral e preço especial",
  guide_scope_body:
    "O preço geral vale para todas as organizações. Se uma organização tem preço especial em um corredor, ele substitui o geral só para ela. Para ver ou alterar os preços de uma organização, escolha-a acima.",
  guide_ranges_title: "Preço por faixa de valor",
  guide_ranges_body:
    "Um preço pode mudar conforme o valor de cada operação: por exemplo, abaixo de 1.000.000 COP paga 1 % e a partir de 1.000.000 paga 0,5 %. Cada operação é vista separadamente; não é o volume acumulado do mês. O percentual da faixa é cobrado sobre o valor inteiro, não por partes.",
  guide_limits_title: "Mínimo e máximo",
  guide_limits_body:
    "A comissão nunca fica abaixo do mínimo nem acima do máximo, seja qual for a faixa da operação.",
  guide_changes_title: "Alterações e histórico",
  guide_changes_body:
    "Um preço nunca é sobrescrito: cada alteração vira uma nova versão com data, autor e motivo, e pode ser agendada para depois. Cada alteração também chega ao canal do Discord da equipe.",
  guide_missing_title: "Corredor sem preço",
  guide_missing_body:
    "Se faltar a comissão ou o custo do provedor em um corredor, todas as entradas e saídas dele são recusadas.",

  // Escopo
  scope_label: "De quem você quer ver os preços?",
  scope_placeholder: "Buscar organização por nome, e-mail ou ID…",
  scope_loading: "Carregando organizações…",
  scope_empty: "Nenhuma organização encontrada.",
  scope_searching: "Buscando organizações…",
  scope_search_error: "Não foi possível concluir a busca; mostrando as organizações já carregadas.",
  scope_catalog_error:
    "Não foi possível carregar o catálogo de organizações; algumas regras podem mostrar o ID em vez do nome.",
  scope_catalog_truncated: "Há mais organizações do que as listadas; digite para buscar todas.",
  scope_global_option: "Preço geral (todas as organizações)",
  scope_global_hint: "Sem organização escolhida: você vê e edita o preço geral.",
  scope_org_hint: "Você vê e edita apenas os preços desta organização.",
  banner_general_title: "Você está no preço geral",
  banner_general_body:
    "O que você alterar aqui vale para todas as organizações sem preço especial nesse corredor.",
  banner_general_orgs: "Organizações com preço especial em algum corredor: {{count}}",
  banner_org_title: "Você está nos preços de {{name}}",
  banner_org_body:
    "O que você alterar aqui afeta só {{name}}. Onde não tem preço especial, paga o preço geral.",
  banner_back_to_general: "Ver o preço geral",

  // Estados de carregamento
  truncated_notice:
    "Foram carregadas {{loaded}} de {{total}} regras. Os números podem estar incompletos até carregar todas.",
  truncated_load_all: "Carregar todas",
  error_load: "Não foi possível carregar as tarifas.",
  error_load_detail: "Nenhum número é exibido: eles nunca são inventados.",
  error_retry: "Tentar novamente",
  routes_error: "Não foi possível carregar o catálogo de corredores.",
  routes_error_detail:
    "Sem ele não é possível calcular preços por corredor. O histórico e as regras continuam disponíveis.",

  // Indicadores (também são o filtro)
  kpi_all_label: "Corredores",
  kpi_all_meta: "{{priced}} com preço completo",
  kpi_unpriced_label: "Sem preço completo",
  kpi_unpriced_meta: "Recusam operações",
  kpi_unpriced_ok: "Todos têm preço",
  kpi_special_label_general: "Com preço especial",
  kpi_special_meta_general: "Alguma organização paga diferente",
  kpi_special_label_org: "Com preço especial",
  kpi_special_meta_org: "Onde esta organização não paga o geral",
  kpi_negative_label: "Margem negativa",
  kpi_negative_meta: "A Coloca perde em cada operação",
  kpi_scheduled_label: "Alterações agendadas",
  kpi_scheduled_meta: "Começam mais tarde",
  kpi_unavailable: "Indisponível",

  // Abas
  tab_corridors: "Corredores",
  tab_history: "Histórico de alterações",
  tab_commissions: "Regras de comissão",
  tab_costs: "Regras de custo",

  // Valores de exemplo
  examples_label: "Números calculados com uma operação de",
  examples_edit_aria: "Alterar o valor de exemplo em {{currency}}",
  examples_popover_title: "Valor de exemplo em {{currency}}",
  examples_popover_hint: "Muda apenas os números desta tela, não os preços.",
  examples_reset: "Restaurar",

  // Aba de corredores
  corridors_th_corridor: "Corredor",
  corridors_th_commission_general: "Comissão geral",
  corridors_th_commission_org: "Comissão da organização",
  corridors_th_special: "Preço especial",
  corridors_th_cost: "Custo do provedor",
  corridors_th_client: "Cliente paga",
  client_pays_taxes: "Inclui {{taxes}}",
  corridors_th_margin: "Margem Coloca",
  corridors_th_status: "Status",
  corridors_empty_title: "Não há corredores ativos",
  corridors_empty_description:
    "Os preços valem para corredores configurados. Enquanto não existir nenhum, não há o que precificar.",
  corridors_filtered_empty_title: "Nenhum corredor neste filtro",
  corridors_filtered_empty_description: "Escolha outro cartão acima para ver mais corredores.",
  coverage_priced: "Com preço",
  coverage_partial: "Falta um preço",
  coverage_unpriced: "Sem preço",
  missing_commission: "Falta a comissão",
  missing_cost: "Falta o custo",
  source_special: "Preço especial",
  source_general: "Preço geral",
  source_general_baseline: "Geral: {{price}}",
  source_no_general: "Sem preço geral",
  special_count: "{{count}} org.",
  special_none: "Nenhuma",
  special_popover_title: "Organizações com preço especial",
  special_popover_hint: "Pagam este preço em vez do geral. Escolha uma para ver ou alterar seus preços.",
  shadowed_warning:
    "Tem um preço especial que não se aplica aqui: uma regra geral mais específica vence. Dê um preço especial neste corredor para que se aplique.",
  scheduled_chip: "Alteração agendada",
  cost_same_for_all: "O custo do provedor é o mesmo para todas as organizações.",
  negative_margin_tooltip:
    "A Coloca absorve o custo do provedor e ele supera a comissão: perde dinheiro em cada operação deste corredor.",
  why_banner:
    "Um corredor sem comissão ou sem custo do provedor recusa todas as entradas e saídas com «não há configuração de comissão ativa».",
  tier_applied: "faixa {{tier}}",
  action_edit_commission: "Editar comissão",
  action_give_special: "Dar preço especial",
  action_change_special: "Alterar preço especial",
  action_back_to_general: "Voltar ao preço geral",
  action_edit_cost: "Editar custo do provedor",
  action_history: "Histórico",
  action_view_rules: "Ver regras",
  action_more_aria: "Mais ações para {{corridor}}",

  // Modelo econômico
  model_pass_through: "Custo cobrado do cliente",
  model_absorbed: "Custo absorvido pela Coloca",
  model_pass_through_help:
    "O cliente paga a comissão mais o custo do provedor. A Coloca fica com a comissão.",
  model_absorbed_help:
    "O cliente paga só a comissão. A Coloca paga o custo do provedor com ela: a margem pode ser negativa.",

  // Enumerações
  direction_payin: "Entrada",
  direction_payout: "Saída",
  kind_commission: "Comissão Coloca",
  kind_cost: "Custo do provedor",
  role_general: "Preço geral",
  role_special: "Preço especial",
  role_special_of: "Especial de {{name}}",
  role_cost: "Custo do provedor",

  // Status derivado
  status_active: "Vigente",
  status_scheduled: "Agendado",
  status_superseded: "Substituído",
  status_expired: "Vencido",
  status_disabled: "Desativado",

  // Chips de escopo
  scope_general: "Todas as organizações",
  scope_any_cost_route: "Qualquer rota de custo",
  scope_any_country: "Qualquer país",
  scope_any_rail: "Qualquer trilho",
  scope_any_currency: "Qualquer moeda",
  scope_any_direction: "Entradas e saídas",
  scope_cost_route: "Rota de custo · {{count}} corredores",
  scope_cost_route_inactive: "Rota de custo · sem corredor ativo",

  // Filtros
  filters_button: "Filtros",
  filters_title: "Filtros",
  filters_apply: "Aplicar",
  filter_corridor_label: "Corredor",
  filter_corridor_all: "Todos os corredores",
  filter_direction_label: "Direção",
  filter_direction_any: "Entradas e saídas",
  filter_route_label: "Rota de custo",
  filter_route_all: "Todas as rotas de custo",
  filter_show_superseded: "Mostrar substituídos e vencidos",
  filter_show_scheduled: "Mostrar agendados",
  filter_clear: "Limpar filtros ({{count}})",

  // Grupos de regras
  spec_aria: "{{count}} de 6 dimensões de escopo definidas",
  spec_hint: "Regras mais específicas vencem as mais gerais.",
  formula_min: "mín",
  formula_max: "máx",
  formula_ranges: "{{count}} faixas de valor",
  formula_any_currency: "moeda da operação",
  badge_ranges: "Por faixa de valor",
  range_from_to: "{{from}} a menos de {{to}}",
  range_from: "{{from}} em diante",
  range_base: "preço base",
  group_effective_since: "Vigente desde {{date}}",
  group_versions: "Alterações: {{count}}",
  group_scheduled_chip: "Alteração agendada · {{date}}",
  group_new_version: "Alterar o preço desta regra",
  group_duplicate: "Copiar para outro escopo",
  group_expand_aria: "Ver o histórico de alterações desta regra",
  rules_general_only_note:
    "Aqui você vê só as regras do preço geral. Escolha uma organização acima para ver seus preços especiais.",

  // Versões
  stack_th_version: "Versão",
  stack_th_price: "Preço",
  stack_th_effective: "Vigência",
  stack_th_change: "Alteração",
  stack_th_status: "Status",
  stack_th_author: "Autor",
  stack_th_reason: "Motivo",
  stack_th_created: "Registrado",
  stack_empty_value: "—",
  stack_actions_aria: "Ações da versão {{version}}",
  stack_delete_menu: "Corrigir: excluir esta alteração",

  // Períodos e tendências
  period_range: "{{from}} → {{to}}",
  period_open: "Desde {{from}}",
  period_starts: "Começa em {{from}}",
  trend_new: "Primeiro preço",
  trend_up: "Subiu",
  trend_down: "Baixou",
  trend_same: "Igual no exemplo",
  trend_zero: "Ficou em 0",

  // Estados vazios
  empty_commissions_title: "Não há regras de comissão",
  empty_costs_title: "Não há regras de custo do provedor",
  empty_description:
    "Enquanto um corredor não tiver comissão e custo, todas as entradas e saídas dele são recusadas.",
  empty_cta: "Criar a primeira regra",
  empty_filtered_title: "Nenhuma regra corresponde a estes filtros",
  empty_filtered_description: "Amplie ou limpe os filtros para ver as regras.",
  empty_filtered_cta: "Limpar filtros",

  // Regra avançada
  dialog_title_new: "Nova regra avançada",
  dialog_title_version: "Alterar o preço desta regra",
  dialog_title_duplicate: "Copiar a regra para outro escopo",
  dialog_subtitle:
    "Para regras que cobrem vários corredores. Para um só corredor, use os botões da aba Corredores.",
  dialog_section_kind: "1 · O que você está precificando?",
  dialog_section_scope: "2 · Onde se aplica?",
  dialog_section_price: "3 · Preço",
  dialog_kind_commission_description: "O que cobramos da organização. É receita.",
  dialog_kind_cost_description: "O que o provedor de pagamentos cobra da Coloca. É custo.",
  dialog_kind_locked: "fixo para esta regra",
  dialog_scope_locked: "escopo fixo: só mudam o preço e a vigência",
  dialog_corridor_label: "Corredor",
  dialog_corridor_placeholder: "Selecione um corredor…",
  dialog_corridor_helper:
    "Uma só seleção preenche país, moeda, trilho e direção. Marque «qualquer» para ampliar a regra.",
  dialog_any_country: "Qualquer país",
  dialog_any_rail: "Qualquer trilho",
  dialog_any_currency: "Qualquer moeda",
  dialog_any_direction: "Entradas e saídas",
  dialog_who_label: "Para quem",
  dialog_who_general: "Preço geral: todas as organizações sem preço especial",
  dialog_who_special: "Preço especial: só {{name}}",
  dialog_cost_general_only:
    "O custo do provedor é igual para todas as organizações. Para criá-lo, volte ao preço geral.",
  dialog_route_label: "Rota de custo",
  dialog_route_any: "Qualquer rota de custo",
  dialog_route_pick_corridor: "Selecione um corredor primeiro",
  dialog_route_helper: "Derivada do corredor escolhido e enviada com a regra.",
  dialog_sentence: "Vale para {{direction}} em {{country}} via {{rail}} em {{currency}}, para {{who}}.",
  dialog_general_coverage: "Esta regra geral cobre {{count}} corredores ativos.",
  sentence_direction_both: "entradas e saídas",
  sentence_any_country: "qualquer país",
  sentence_any_rail: "qualquer trilho",
  sentence_any_currency: "qualquer moeda",
  sentence_who_general: "todas as organizações sem preço especial",
  sentence_who_any_route: "qualquer rota de custo",
  sentence_who_route: "esta rota de custo",
  warn_shadow:
    "Já existe uma regra mais específica que cobre {{who}} em parte deste escopo. Esta regra não se aplicará onde aquela coincidir.",
  warn_shadow_who_org: "{{name}}",
  warn_shadow_who_route: "uma rota de custo específica",
  warn_collision:
    "Já existe uma versão desta regra que começa exatamente nessa data e hora. Escolha outra hora.",

  // Preço
  price_percentage_label: "Percentual",
  price_percentage_helper: "De 0 a 100, até 4 casas decimais. Cobrado sobre o valor da operação.",
  price_fixed_label: "Valor fixo",
  price_fixed_helper: "Somado em cada operação.",
  price_min_label: "Comissão mínima",
  price_min_helper: "Piso da comissão, não do valor.",
  price_max_label: "Comissão máxima",
  price_max_helper: "Teto da comissão. Vazio = sem limite.",
  price_max_placeholder: "Sem limite",
  price_structure_label: "Tipo de preço",
  price_single_label: "Preço único",
  price_single_hint: "O mesmo percentual e fixo para qualquer valor.",
  price_ranges_label: "Preço por faixa de valor",
  price_ranges_hint: "Muda conforme o valor de cada operação (não por volume).",
  price_base_title: "Preço base",
  currency_operation: "moeda da op.",

  // Faixas
  tiers_legend: "Faixas pelo valor de cada operação",
  tiers_th_from: "De",
  tiers_th_to: "Até (sem incluir)",
  tiers_th_fixed: "Fixo",
  tiers_th_percentage: "Percentual",
  tiers_and_above: "em diante",
  tiers_base_row: "Abaixo de {{amount}}: usa o preço base acima",
  tiers_add: "Adicionar faixa",
  tiers_remove_aria: "Remover faixa",
  tiers_help:
    "O valor bruto de cada operação é visto separadamente: não é o volume acumulado do mês. O percentual da faixa é cobrado sobre o valor inteiro, não por partes, e a comissão mínima e máxima valem em todas as faixas.",
  tiers_example: "Uma operação de {{amount}} cai em «{{range}}» e paga {{fee}} de comissão.",
  tiers_example_label: "Testar com",
  tiers_ruler_aria: "Faixas de valor e o preço de cada uma",

  // Vigência
  eff_now_label: "Vigente imediatamente",
  eff_date_label: "Data de início",
  eff_time_label: "Hora",
  eff_resolved: "Começa em {{datetime}} ({{offset}})",
  eff_pick: "Escolha data e hora",
  eff_time_note: "A hora importa: duas versões da mesma regra não podem começar no mesmo instante.",
  valid_until_label: "Válida até",
  valid_until_helper: "Vazio = sem data de fim.",
  reason_label: "Motivo da alteração",
  reason_helper: "Fica no histórico e no alerta do Discord.",
  reason_placeholder: "Ex.: acordo comercial assinado em 8 de outubro",
  version_notice:
    "Será a versão {{next}} desta regra. A versão {{previous}} fica no histórico e deixa de valer quando esta começar.",

  // Pré-visualização
  preview_title: "Pré-visualização",
  preview_amount_label: "Valor da operação",
  preview_gross: "Bruto",
  preview_commission: "Comissão Coloca",
  preview_cost: "Custo do provedor",
  preview_client: "Total que o cliente paga",
  preview_net: "Líquido ao beneficiário",
  preview_margin: "Margem Coloca",
  preview_badge_tier: "Aplica a faixa {{tier}}",
  preview_badge_min: "Subiu ao mínimo de {{amount}}",
  preview_badge_max: "Baixou ao máximo de {{amount}}",
  preview_missing_cost: "Este corredor ainda não tem custo do provedor: aparece «—», nunca 0.",
  preview_missing_commission: "Este corredor ainda não tem comissão: aparece «—», nunca 0.",
  preview_pick_corridor: "Selecione um corredor para estimar a outra parte.",
  preview_breakeven:
    "Operações abaixo de {{amount}} serão recusadas: a comissão não deixaria nada para o beneficiário.",
  preview_breakeven_band:
    "Alguns valores intermediários serão recusados: uma faixa eleva a comissão acima do que o valor deixa. Revise as faixas antes de salvar.",
  preview_breakeven_all_refused:
    "Com este preço o corredor recusaria todas as operações: nenhum valor deixa algo para o beneficiário.",
  preview_negative_margin:
    "A Coloca absorve o custo e ele supera a comissão: perde {{amount}} em cada operação deste valor.",
  preview_disclaimer:
    "Estimativa com as mesmas regras do motor de pagamentos. A comissão final é calculada ao criar a operação.",
  preview_toggle_aria: "Ver o detalhamento completo",

  // Editar o preço de um corredor
  edit_title_general: "Editar a comissão geral",
  edit_title_special: "Preço especial de {{name}}",
  edit_title_cost: "Editar o custo do provedor",
  edit_applies_general: "Vale para todas as organizações sem preço especial",
  edit_applies_special: "Vale só para {{name}}",
  edit_applies_cost: "O que o provedor cobra da Coloca neste corredor",
  edit_target_label: "O que você quer alterar?",
  edit_target_broad: "A regra que cobre {{count}} corredores",
  edit_target_broad_hint: "Altera o preço em todos: {{corridors}}",
  edit_target_corridor: "Só este corredor",
  edit_target_corridor_hint: "Este corredor terá seu próprio preço; os demais não mudam.",
  edit_compare_title: "Como fica",
  edit_compare_amount: "Operação de {{amount}}",
  edit_compare_today: "Hoje",
  edit_compare_new: "Com a alteração",
  edit_compare_none: "Sem preço",
  edit_compare_client: "Cliente paga",
  edit_compare_margin: "Margem Coloca",
  edit_also_title: "Aplicar este preço especial também em",
  edit_also_hint: "Só corredores em {{currency}}. Um é salvo por corredor.",
  edit_special_broad_note:
    "{{name}} já tem um preço especial mais amplo que cobre este corredor. Este corredor terá o seu próprio.",
  edit_special_no_general:
    "Este corredor não tem preço geral: hoje só funciona para organizações com preço especial.",
  edit_shadowed_note:
    "Seu preço especial atual não se aplica aqui porque uma regra geral mais específica vence; este vai se aplicar.",
  edit_next: "Revisar a alteração",
  edit_back: "Voltar",
  edit_save: "Salvar preço",

  // Revisão de uma alteração geral
  review_title: "Revise antes de salvar",
  review_intro_general: "Você vai alterar a comissão geral em {{count}} corredores:",
  review_intro_cost: "Você vai alterar o custo do provedor em {{count}} corredores:",
  review_th_corridor: "Corredor",
  review_th_before: "Hoje",
  review_th_after: "Com a alteração",
  review_orgs_kept: "Estas organizações têm preço especial aqui e não mudam ({{count}}):",
  review_orgs_none: "Nenhuma organização tem preço especial aqui: todas passam a pagar o novo preço.",
  review_zero_warning:
    "A nova comissão é 0: nenhuma organização sem preço especial pagará comissão nestes corredores.",
  review_drop_warning: "A comissão cai mais da metade na operação de exemplo.",
  review_ack: "Entendo que isto altera o preço de todas as organizações sem preço especial",
  review_ack_cost: "Entendo que isto altera o custo do provedor nestes corredores",

  // Salvamento em vários corredores
  save_partial: "Salvo em {{ok}} de {{total}} corredores. Tente de novo os que faltam.",
  save_retry: "Tentar de novo os que faltam",
  save_row_ok: "Salvo",
  save_row_failed: "Não salvo",
  save_row_pending: "Pendente",

  // Voltar ao preço geral
  remove_title: "Voltar ao preço geral?",
  remove_description: "{{name}} deixa de ter preço especial em {{corridor}}.",
  remove_after_title: "Depois vai pagar",
  remove_after_general: "{{price}} (preço geral)",
  remove_after_other_special: "{{price}} (outro preço especial mais amplo)",
  remove_after_none: "Nada: este corredor não tem preço geral, então vai recusar as operações de {{name}}.",
  remove_broad_note: "Este preço especial cobre {{count}} corredores e todos voltam ao geral:",
  remove_versions_title: "Estas versões serão excluídas",
  remove_confirm: "Voltar ao preço geral",
  remove_progress: "Excluindo {{done}} de {{total}}…",
  remove_partial:
    "Foram excluídas {{done}} de {{total}} versões e o preço vigente ainda não mudou. Tente de novo para terminar.",

  // Histórico
  history_drawer_title: "Histórico · {{corridor}}",
  history_drawer_desc_general: "Alterações do preço geral e do custo do provedor neste corredor.",
  history_drawer_desc_org:
    "Alterações do preço especial de {{name}}, do preço geral e do custo do provedor neste corredor.",
  history_empty: "Ainda não há alterações.",
  history_deleted_note:
    "Alterações excluídas não aparecem aqui porque a API não as retorna; elas chegaram ao Discord.",
  history_recorded: "Registrado em {{date}} por {{author}}",
  history_reason: "Motivo: {{reason}}",
  history_no_reason: "Sem motivo",
  history_not_applying: "Regra mais ampla: hoje outra mais específica a substitui.",
  history_unknown_author: "autor desconhecido",
  feed_filter_role: "Tipo de preço",
  feed_role_all: "Todos",
  feed_role_general: "Preço geral",
  feed_role_special: "Preços especiais",
  feed_role_cost: "Custos do provedor",
  feed_only_zero: "Só alterações que ficaram em 0",
  feed_count: "Alterações: {{count}}",
  feed_load_more: "Ver mais",
  feed_today: "Hoje",
  feed_yesterday: "Ontem",
  feed_empty_title: "Não há alterações com estes filtros",
  feed_empty_description: "Mude os filtros para ver mais.",

  // Explicação de cada aba
  tab_intro_corridors:
    "Cada linha é um corredor: um país, um trilho e uma direção. Você vê quanto uma operação de exemplo paga hoje, quem paga diferente, e daqui altera o preço desse corredor.",
  tab_intro_history:
    "Todas as alterações de preço, da mais recente à mais antiga: de quanto para quanto, quem fez, por quê e desde quando vale.",
  tab_intro_commissions:
    "As comissões como o sistema as guarda. Uma regra pode cobrir vários corredores e a mais específica vence. Use-as para alterações que abrangem vários corredores de uma vez.",
  tab_intro_costs:
    "O que cada provedor cobra da Coloca, como regras. É igual para todas as organizações e define a margem de cada corredor.",

  // Regra avançada (página)
  rule_page_subtitle:
    "Para um preço que cobre vários corredores de uma vez. Para um só corredor, use «Editar» na aba Corredores.",
  rule_back: "Voltar às tarifas",
  rule_source_missing: "Não encontramos a regra de origem: talvez tenha sido excluída.",
  rule_step_kind: "O quê",
  rule_step_where: "Onde",
  rule_step_price: "Preço",
  rule_step_review: "Revisar",
  rule_kind_title: "O que você quer precificar?",
  rule_where_title: "Onde se aplica?",
  rule_where_hint: "Escolha país, trilho e direção. O que deixar em «todos» amplia a regra.",
  rule_country_label: "País",
  rule_country_all: "Todos os países",
  rule_rail_label: "Trilho",
  rule_rail_all: "Todos os trilhos",
  rule_direction_label: "Direção",
  rule_direction_both: "Entradas e saídas",
  rule_cost_pin: "Só para a rota de custo atual",
  rule_cost_pin_hint: "Se estes corredores mudarem de provedor, a regra deixa de valer.",
  rule_covers: "Corredores que cobre: {{count}}",
  rule_covers_none: "Nenhum corredor ativo corresponde a esta combinação.",
  rule_applies: "Vai se aplicar",
  rule_overridden: "Não se aplica: aqui manda uma regra mais específica",
  rule_validation_no_corridor: "Escolha uma combinação em que a regra se aplique a pelo menos um corredor.",
  rule_price_title: "Quanto se cobra?",
  rule_when_title: "Desde quando?",
  rule_when_now: "Assim que você salvar",
  rule_when_from: "Desde {{date}}",
  rule_review_applies_on: "Como o preço muda nos corredores onde vai se aplicar ({{count}}):",
  rule_summary_title: "Resumo",
  rule_summary_kind: "O quê",
  rule_summary_who: "Para quem",
  rule_summary_where: "Onde",
  rule_summary_where_value: "Vale em {{applies}} de {{total}} corredores",
  rule_summary_price: "Preço",
  rule_summary_when: "Vigência",
  rule_summary_source: "Parte da versão {{version}}: {{price}}",
  rule_next: "Próximo",
  rule_back_step: "Voltar",
  rule_save: "Salvar regra",

  // Envio
  dialog_cancel: "Cancelar",
  dialog_submit: "Salvar regra",
  validation_percentage: "Informe um percentual entre 0 e 100 com até 4 casas decimais.",
  validation_money: "Informe um valor positivo com até 8 casas decimais.",
  validation_corridor_required: "Selecione um corredor ou marque todas as dimensões como «qualquer».",
  validation_tier_threshold: "Cada faixa deve começar em 0 ou mais.",
  validation_tier_threshold_unique: "Duas faixas não podem começar no mesmo valor.",
  validation_tier_fixed: "O fixo de cada faixa deve ser 0 ou mais.",
  validation_tier_percentage: "O percentual de cada faixa deve estar entre 0 e 100.",
  validation_valid_until: "«Válida até» deve ser posterior ao início.",
  validation_valid_from_required: "Escolha a data e a hora de início.",
  validation_reason_required: "Escreva o motivo: alterações do preço geral ficam no histórico.",
  validation_ack_required: "Confirme que entende a quem a alteração afeta.",

  toast_created: "Regra salva: versão {{version}}, vigente desde {{date}}",
  toast_saved_general: "Comissão geral atualizada",
  toast_saved_special: "Preço especial salvo para {{name}}",
  toast_saved_cost: "Custo do provedor atualizado",
  toast_scheduled: "Alteração agendada para {{date}}",
  toast_removed: "{{name}} volta ao preço geral em {{corridor}}",
  error_create: "Não foi possível salvar o preço.",
  error_no_write_permission: "Sua conta não pode alterar tarifas.",

  // Corrigir: excluir uma alteração
  delete_title: "Excluir esta alteração?",
  delete_semantics:
    "Use só para corrigir um erro. Para mudar um preço, salve um novo: assim ele fica no histórico.",
  delete_after_title: "Depois de excluir, vale",
  delete_after_none: "Nada: o corredor vai recusar operações",
  delete_escalate_commission:
    "Depois de excluir, estes corredores ficam sem comissão e recusam todas as entradas e saídas ({{count}}):",
  delete_escalate_cost:
    "Depois de excluir, estes corredores ficam sem custo do provedor e recusam todas as entradas e saídas ({{count}}):",
  delete_cancel: "Cancelar",
  delete_confirm: "Excluir alteração",
  toast_deleted: "Alteração v{{version}} excluída",
  error_delete: "Não foi possível excluir a alteração.",
  error_delete_missing: "Esta alteração não existe mais.",
};
